var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appBody bg-white pb-5"},[(_vm.error)?_c('van-empty',{attrs:{"image":"error","description":"交易信息不存在！"}}):_c('div',{staticClass:"text-center font-15 mt-3"},[_vm._v(" 正在处理支付结果，即将跳转到订单详情页面... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }